import * as React from "react";
import { forwardRef } from "react";
const SvgDot = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 5 5" ref={ref} {...props}><circle cx={1.5} cy={1.5} r={1.5} fill="#D81818" /></svg>;
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;